import { useState, useEffect } from "react";

const RU_ALPHA = "АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ".split("");

export default function WheelWordPlayer({
  phase, spinResult, spinResultVisible, wordMask, guessedLetters,
  roundScores, eliminated, currentPlayer,
  hint1Used, hint2Used, letterResult, wordResult,
  hint, roundEnd, category, playerName,
  onSpin, onGuessLetter, onGuessWord, onJokerPick, onHint, onPass,
}) {
  const [wordInput, setWordInput] = useState("");
  const [tab, setTab] = useState("letter");

  // Reset input on turn change
  useEffect(() => { setWordInput(""); setTab("letter"); }, [currentPlayer, phase]);

  const myTurn  = currentPlayer === (sessionStorage.getItem("playerName") || playerName);
  const isElim  = (eliminated || []).includes(sessionStorage.getItem("playerName") || playerName);
  const myScore = (roundScores || {})[sessionStorage.getItem("playerName") || playerName] || 0;
  const available = RU_ALPHA.filter(l => !(guessedLetters || []).includes(l));

  // ── Ячейки слова ────────────────────────────────────────────────────────────
  const WordCells = () => (
    <div style={{ display: "flex", flexWrap: "wrap", gap:"var(--gap-sm)", justifyContent: "center", margin: "0.6rem 0" }}>
      {(wordMask || []).map((ch, i) =>
        ch === " "
          ? <div key={i} style={{ width: "0.75rem" }} />
          : <div key={i} style={{
              width: "2rem", height: "2.5rem",
              background: ch ? "#3dffa022" : "#0d0025",
              border: `2px solid ${ch ? "#3dffa0" : "#9b5de533"}`,
              borderRadius: "0.4rem", display: "flex",
              alignItems: "center", justifyContent: "center",
              fontFamily: "'Fredoka One',sans-serif", fontSize:"var(--fs-lg)",
              color: ch ? "#3dffa0" : "transparent", transition: "all 0.3s",
            }}>{ch || "·"}</div>
      )}
    </div>
  );

  // ── Кнопка ──────────────────────────────────────────────────────────────────
  const Btn = ({ onClick, bg = "#9b5de5", color = "#fff", disabled = false, children, style = {} }) => (
    <button onClick={disabled ? undefined : onClick} style={{
      fontFamily: "'Fredoka One',sans-serif", fontSize:"var(--fs-md)",
      background: disabled ? "#1a1a1a" : bg,
      color: disabled ? "#444" : color,
      border: `2.5px solid ${disabled ? "#333" : "#000"}`,
      borderRadius: "0.75rem",
      boxShadow: disabled ? "none" : "3px 3px 0 #000",
      padding:"var(--pad-sm) var(--pad-md)", width: "100%",
      cursor: disabled ? "default" : "pointer", ...style,
    }}>{children}</button>
  );

  // ── Конец раунда ─────────────────────────────────────────────────────────────
  if (roundEnd) {
    const myName = sessionStorage.getItem("playerName") || playerName;
    const won = roundEnd.winner === myName;
    return (
      <div style={{ textAlign: "center", padding: "2rem 1rem" }}>
        <div style={{ fontSize: "3.5rem", marginBottom: "0.5rem" }}>
          {roundEnd.solved ? (won ? "🏆" : "😊") : "😔"}
        </div>
        <p style={{
          fontFamily: "'Fredoka One',sans-serif", fontSize:"var(--fs-xl)",
          color: won ? "#ffe600" : roundEnd.solved ? "#3dffa0" : "#f44336", marginBottom: "0.5rem",
        }}>
          {won ? "Ты угадал слово!" : roundEnd.solved ? "Кто-то угадал слово!" : "Никто не угадал"}
        </p>
        <p style={{ fontFamily: "'Fredoka One',sans-serif", fontSize:"var(--fs-3xl)", color: "#ffe600", letterSpacing: "0.15em" }}>
          {roundEnd.word}
        </p>
        {(roundEnd.round_scores || {})[myName] > 0 && (
          <p style={{ fontFamily: "'Nunito',sans-serif", color: "#3dffa0", marginTop: "0.5rem" }}>
            +{roundEnd.round_scores[myName]} очков
          </p>
        )}
      </div>
    );
  }

  // ── Вылетел ──────────────────────────────────────────────────────────────────
  if (isElim) return (
    <div style={{ textAlign: "center", padding: "2rem 1rem" }}>
      <div style={{ fontSize: "3rem", marginBottom: "0.75rem" }}>💀</div>
      <p style={{ fontFamily: "'Fredoka One',sans-serif", fontSize:"var(--fs-xl)", color: "#f44336" }}>
        Ты вылетел из раунда
      </p>
      <WordCells />
      <p style={{ fontFamily: "'Nunito',sans-serif", color: "#444", fontSize:"var(--fs-sm)", marginTop: "0.5rem" }}>
        Следующий раунд скоро!
      </p>
    </div>
  );

  // ── Не мой ход ───────────────────────────────────────────────────────────────
  if (!myTurn) return (
    <div style={{ textAlign: "center", padding: "1.5rem 1rem" }}>
      <p style={{ fontFamily: "'Fredoka One',sans-serif", fontSize:"var(--fs-md)", color: "#9b5de5", marginBottom: "0.5rem" }}>
        ⏳ Ход: <strong style={{ color: "#ffe600" }}>{currentPlayer}</strong>
      </p>
      <WordCells />
      {category && <p style={{ fontFamily: "'Nunito',sans-serif", color: "#555", fontSize:"var(--fs-sm)" }}>📂 {category}</p>}
      {(guessedLetters || []).length > 0 && (
        <p style={{ fontFamily: "'Nunito',sans-serif", color: "#444", fontSize:"var(--fs-sm)", marginTop: "0.4rem" }}>
          Названы: {guessedLetters.join(" · ")}
        </p>
      )}
      {letterResult && (
        <p style={{ fontFamily: "'Fredoka One',sans-serif", fontSize:"var(--fs-md)", color: letterResult.found ? "#3dffa0" : "#f44336", marginTop: "0.75rem" }}>
          {letterResult.found ? "✅ Буква есть!" : "❌ Буквы нет"}
        </p>
      )}
      <p style={{ fontFamily: "'Nunito',sans-serif", color: "#333", fontSize:"var(--fs-sm)", marginTop: "0.75rem" }}>
        Счёт раунда: <span style={{ color: "#ffe600" }}>{myScore}</span>
      </p>
    </div>
  );

  // ── МОЙ ХОД: ожидание (bankrupt / skip / колесо крутится) ───────────────────
  if (phase === "waiting" || phase === "watching") {
    const msg =
      spinResultVisible && spinResult?.type === "bankrupt" ? { t: "💸 Банкрот! Очки сгорели", c: "#f44336" }
      : spinResultVisible && spinResult?.type === "skip"   ? { t: "⏭ Ход пропущен", c: "#9C27B0" }
      : wordResult && !wordResult.correct                  ? { t: "💀 Неверное слово — ты вылетел", c: "#f44336" }
      : spinResult && !spinResultVisible                   ? { t: "🎡 Колесо крутится...", c: "#ffe600" }
      : { t: "⏳ Ждёшь своего хода...", c: "#555" };
    return (
      <div style={{ textAlign: "center", padding: "2rem 1rem" }}>
        <p style={{ fontFamily: "'Fredoka One',sans-serif", fontSize:"var(--fs-lg)", color: msg.c, marginBottom: "0.75rem" }}>{msg.t}</p>
        <WordCells />
        <p style={{ fontFamily: "'Nunito',sans-serif", color: "#333", fontSize:"var(--fs-sm)", marginTop: "0.75rem" }}>
          Счёт раунда: <span style={{ color: "#ffe600" }}>{myScore}</span>
        </p>
      </div>
    );
  }

  // ── МОЙ ХОД: крути колесо ──────────────────────────────────────────────────
  if (phase === "spin") return (
    <div style={{ padding: "1rem" }}>
      <p style={{ fontFamily: "'Fredoka One',sans-serif", fontSize:"var(--fs-lg)", color: "#ffe600", textAlign: "center", marginBottom: "0.6rem" }}>
        🎰 Твой ход — крути колесо!
      </p>
      <WordCells />
      {category && <p style={{ fontFamily: "'Nunito',sans-serif", color: "#555", fontSize:"var(--fs-sm)", textAlign: "center", marginBottom: "0.4rem" }}>📂 {category}</p>}
      {(guessedLetters || []).length > 0 && (
        <p style={{ fontFamily: "'Nunito',sans-serif", color: "#444", fontSize:"var(--fs-sm)", textAlign: "center", marginBottom: "0.6rem" }}>
          Уже: {guessedLetters.join(" ")}
        </p>
      )}
      {letterResult?.found && (
        <p style={{ fontFamily: "'Fredoka One',sans-serif", color: "#3dffa0", textAlign: "center", fontSize:"var(--fs-md)", marginBottom: "0.6rem" }}>
          ✅ «{letterResult.letter}» есть — крути снова!
        </p>
      )}
      <Btn onClick={onSpin} bg="#9b5de5" style={{ fontSize:"var(--fs-xl)", padding: "0.9rem" }}>🎡 Крутить колесо</Btn>
      <div style={{ marginTop: "0.5rem" }}>
        <Btn onClick={onPass} bg="#222" color="#666" style={{ fontSize:"var(--fs-sm)", border: "1.5px solid #333", boxShadow: "none" }}>⏭ Пропустить ход</Btn>
      </div>
      <p style={{ fontFamily: "'Nunito',sans-serif", color: "#333", fontSize:"var(--fs-sm)", textAlign: "center", marginTop: "0.75rem" }}>
        Счёт раунда: <span style={{ color: "#ffe600" }}>{myScore}</span>
      </p>
    </div>
  );

  // ── МОЙ ХОД: джокер — выбери любую букву ──────────────────────────────────
  if (phase === "joker") return (
    <div style={{ padding: "1rem" }}>
      <p style={{ fontFamily: "'Fredoka One',sans-serif", fontSize:"var(--fs-lg)", color: "#FFD600", textAlign: "center", marginBottom: "0.6rem" }}>
        🃏 ДЖОКЕР! Выбери любую букву
      </p>
      <WordCells />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(6,1fr)", gap:"var(--gap-sm)", marginTop: "0.5rem" }}>
        {available.map(l => (
          <button key={l} onClick={() => onJokerPick(l)} style={{
            fontFamily: "'Fredoka One',sans-serif", fontSize:"var(--fs-md)",
            background: "#1a1500", color: "#FFD600",
            border: "2px solid #FFD60066", borderRadius: "0.5rem",
            padding: "0.5rem 0.2rem", cursor: "pointer",
          }}>{l}</button>
        ))}
      </div>
    </div>
  );

  // ── МОЙ ХОД: action — называй букву / слово / подсказку ───────────────────
  if (phase === "action") {
    const spinColor = spinResult?.type === "mult" ? "#3dffa0" : "#9b5de5";
    return (
      <div style={{ padding: "1rem" }}>
        {spinResult && spinResultVisible && (
          <div style={{
            textAlign: "center", marginBottom: "0.6rem", padding: "0.35rem 0.75rem",
            background: `${spinColor}22`, border: `2px solid ${spinColor}`, borderRadius: "0.75rem",
            fontFamily: "'Fredoka One',sans-serif", fontSize:"var(--fs-lg)", color: spinColor,
          }}>
            Выпало {spinResult.label}
          </div>
        )}
        <WordCells />
        {/* Tabs */}
        <div style={{ display: "flex", gap: "0.35rem", marginBottom: "0.6rem" }}>
          {[
            { k: "letter", label: "Буква",       bg: "#9b5de5" },
            { k: "word",   label: "🎯 Слово",    bg: "#ff3cac" },
            { k: "hint",   label: "💡 Подсказка", bg: "#ffe600", c: "#000" },
          ].map(t => (
            <button key={t.k} onClick={() => setTab(t.k)} style={{
              flex: 1, fontFamily: "'Fredoka One',sans-serif", fontSize:"var(--fs-sm)",
              background: tab === t.k ? t.bg : "#1a0033",
              color: tab === t.k ? (t.c || "#fff") : "#555",
              border: `2px solid ${tab === t.k ? t.bg : "#333"}`,
              borderRadius: "0.6rem", padding: "0.45rem 0.2rem", cursor: "pointer",
            }}>{t.label}</button>
          ))}
        </div>

        {tab === "letter" && (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(6,1fr)", gap: "0.28rem" }}>
            {available.map(l => (
              <button key={l} onClick={() => onGuessLetter(l)} style={{
                fontFamily: "'Fredoka One',sans-serif", fontSize:"var(--fs-md)",
                background: "#0d0025", color: "#fff",
                border: "2px solid #9b5de544", borderRadius: "0.45rem",
                padding: "0.5rem 0.2rem", cursor: "pointer",
              }}
              onTouchStart={e => e.currentTarget.style.background = "#9b5de5"}
              onTouchEnd={e => e.currentTarget.style.background = "#0d0025"}
              >{l}</button>
            ))}
          </div>
        )}

        {tab === "word" && (
          <div style={{ textAlign: "center" }}>
            <p style={{ fontFamily: "'Nunito',sans-serif", color: "#ff3cac", fontSize:"var(--fs-sm)", marginBottom: "0.5rem" }}>
              ⚠️ Ошибёшься — вылетишь из раунда!
            </p>
            <input
              type="text" value={wordInput}
              onChange={e => setWordInput(e.target.value.toUpperCase())}
              onKeyDown={e => e.key === "Enter" && wordInput.trim() && onGuessWord(wordInput.trim())}
              placeholder="Введи слово..." autoComplete="off"
              style={{
                width: "100%", boxSizing: "border-box", background: "#0d0025",
                border: "2.5px solid #ff3cac55", borderRadius: "0.75rem", color: "#fff",
                padding:"var(--pad-sm) var(--pad-md)", fontFamily: "'Fredoka One',sans-serif",
                fontSize:"var(--fs-xl)", letterSpacing: "0.1em", outline: "none",
                textAlign: "center", marginBottom: "0.5rem",
              }}
            />
            <Btn onClick={() => wordInput.trim() && onGuessWord(wordInput.trim())} bg="#ff3cac" disabled={!wordInput.trim()}>
              🎯 Назвать слово
            </Btn>
          </div>
        )}

        {tab === "hint" && (
          <div style={{ display: "flex", flexDirection: "column", gap:"var(--gap-md)" }}>
            <Btn
              onClick={() => !hint1Used && onHint("hint1")} disabled={hint1Used}
              bg="#1a1200" color={hint1Used ? "#333" : "#ffe600"}
              style={{ border: hint1Used ? "1.5px solid #333" : "1.5px solid #ffe600" }}>
              💡 Наводящий вопрос{hint1Used ? " — куплено" : " (-50 очков)"}
            </Btn>
            <Btn
              onClick={() => !hint2Used && onHint("hint2")} disabled={hint2Used}
              bg="#0a1a00" color={hint2Used ? "#333" : "#3dffa0"}
              style={{ border: hint2Used ? "1.5px solid #333" : "1.5px solid #3dffa0" }}>
              🔓 Открыть букву{hint2Used ? " — куплено" : " (-100 очков)"}
            </Btn>
            {hint && (
              <div style={{
                background: "#1a1400", border: "1.5px solid #ffe60055",
                borderRadius: "0.75rem", padding: "0.7rem",
                fontFamily: "'Nunito',sans-serif", fontSize:"var(--fs-md)",
                color: "#ffe600", textAlign: "center",
              }}>
                {hint.text}
              </div>
            )}
          </div>
        )}

        <p style={{ fontFamily: "'Nunito',sans-serif", color: "#333", fontSize:"var(--fs-sm)", textAlign: "center", marginTop: "0.75rem" }}>
          Счёт раунда: <span style={{ color: "#ffe600" }}>{myScore}</span>
        </p>
      </div>
    );
  }

  // Fallback
  return (
    <div style={{ textAlign: "center", padding: "1.5rem 1rem" }}>
      <WordCells />
      <p style={{ fontFamily: "'Nunito',sans-serif", color: "#444", fontSize:"var(--fs-sm)", marginTop: "0.5rem" }}>
        Ход: <strong style={{ color: "#ffe600" }}>{currentPlayer}</strong>
      </p>
    </div>
  );
}
